<template>
    <div component="ContractHeader">
        <div class="filter">
            <div class="select cell">
                <v-autocomplete
                    v-model="filter.actor"
                    :items="getAllActors"
                    class="autocomplete select"
                    clearable
                    dense
                    filled
                    hide-details
                    item-text="meno_priezvisko"
                    item-value="id"
                    label="chose an actor"
                    rounded
                    solo
                    @change="onChange"
                >
                </v-autocomplete>
            </div>

            <v-select
                v-model="filter.from"
                :items="years"
                class="input select"
                clearable
                dense
                filled
                hide-details
                label="from"
                rounded
                solo
                @change="onChange"
            />

            <v-select
                v-model="filter.to"
                :items="years"
                class="input select"
                clearable
                dense
                filled
                hide-details
                label="to"
                rounded
                solo
                @change="onChange"
            />

            <div class="action cell">
                <btn icon="add_circle" text="CONTRACT TEMPLATE" @click="goToContractTemplate"></btn>
            </div>
        </div>

        <div class="filter">
            <v-text-field
                v-model="filter.search"
                v-on:keyup.enter="onChange"
                v-on:click:clear="clear"
                class="search"
                clearable
                hide-details
                label="Search"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Autocomplete from '@/components/.global/Autocomplete.vue';
import lodash from 'lodash';
import { get, set } from 'local-storage';

export const CONTRACT_STORAGE_KEY = 'vc.contract';

export default {
    name: 'ContractHeader',

    components: {
        Autocomplete,
    },

    data: () => ({
        filter: {},
        years: [],
    }),

    async created() {
        for (let year = new Date().getFullYear(); year >= 2000; year--) {
            this.years.push(year);
        }

        let contractParams = get(CONTRACT_STORAGE_KEY);

        const query = this.transformQuery(this.$route.query);

        if (!lodash.isEqual(query, contractParams) && !lodash.isEmpty(query)) {
            contractParams = query;
            set(CONTRACT_STORAGE_KEY, contractParams);
        }

        if (lodash.isObject(contractParams)) {
            this.filter = contractParams;
        }

        if (!lodash.isEmpty(contractParams)) {
            await this.$router.push({ query: contractParams }).catch(() => {});
        }

        await this.loadAllActors();
        await this.loadContractList(contractParams);
    },

    methods: {
        ...mapActions(['loadAllActors', 'loadContractList']),

        transformQuery(query) {
            if (query.from) {
                query.from = parseInt(query.from);
            }

            if (query.to) {
                query.to = parseInt(query.to);
            }

            if (query.actor) {
                query.actor = parseInt(query.actor);
            }

            return query;
        },

        async clear() {
            this.filter.search = '';
            await this.onChange();
        },

        async onChange() {
            set(CONTRACT_STORAGE_KEY, this.filter);

            await this.$router.push({ query: this.filter }).catch(() => {});
            await this.loadContractList(this.filter);
        },

        goToContractTemplate() {
            this.$router.push({ path: '/contract-template' }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getAllActors']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ContractHeader'] {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .filter {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
        width: 100%;

        .search /deep/ .v-input__slot {
            padding-left: 15px !important;
        }
    }

    .select {
        flex: 0.4;
        max-width: 500px;
    }

    .name {
        flex: 0.5;
        padding: 0 20px;

        h3 {
            margin-top: 0;
        }
    }

    .action {
        margin-left: auto;
    }

    .input.select {
        max-width: 150px;
        margin-right: 1rem;
    }

    .autocomplete.select {
        max-width: 300px;
        margin-right: 1rem;
    }
}
</style>
